<button mat-raised-button class=" mat-button-base na-button" [color]="buttonColor" [disabled]="isDisabled"
    (click)="setFieldValueForAllCalibrationSets()">N/A</button>
